import React, { Fragment, useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import Container from 'react-bootstrap/Container';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { logCall, logEmail, logSms } from '../../../common/api';
import { toast } from 'react-toastify';
import TFVideoRecorder from '../RecordVideo';
import TFAudioRecorder from '../../Recorder/audio';
import PersonalVideoIcon from '@mui/icons-material/PersonalVideo';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import MicIcon from '@mui/icons-material/Mic';
import VideocamIcon from '@mui/icons-material/Videocam';
import AWS from 'aws-sdk';
import { formatDate, formatTime, storeMedia, createId } from '../../../common/utils';

import '../modals.css';
import { InputGroup } from 'react-bootstrap';

const LogComms = ( { close, aid, uid, cid, commType, oid, onSave } ) => {
    const [ desc, setDesc ] = useState( '' );
    const [ detailsFormat, setDetailsFormat ] = useState( 'text' );
    const [ details, setDetails ] = useState( '' );
    const [ commDate, setCommDate ] = useState();
    const [ commTime, setCommTime ] = useState();
    const [ duration, setDuration ] = useState();
    const [ direction, setDirection ] = useState( 'outbound' );
    const [ outcome, setOutcome ] = useState( 'talked' );
    const [ ready, setReady ] = useState( false );
    const [ processing, setProcessing ] = useState( false );
    const [ showVideo, setShowVideo ] = useState( false );
    const [ videoFormat, setVideoFormat ] = useState();
    const [ to, setTo ] = useState( '' );
    const [ from, setFrom ] = useState( '' );
    const [ cc, setCc ] = useState( '' );
    
    const [ audioBlob, setAudioBlob ] = useState(null);
    const [ videoBlob, setVideoBlob ] = useState(null);
    const refVideo = useRef(null);
    
    AWS.config.update( { region: 'us-east-1' } );

    useEffect( () => {
        setCommDate( formatDate( new Date() ) );
        setCommTime( formatTime( new Date() ) );
    }, [] );

    useEffect( () => {
        if ( desc && desc.length > 0 ) {
            setReady( true );
        } else {
            setReady( false );
        }
    }, [ desc ] );

    const create = async () => {
        setProcessing( true );

        let mediaUrl;
        if ( detailsFormat === 'audio' ) {
            mediaUrl = await storeMedia( aid, uid, createId( 'aud' ) + '.mkv', audioBlob, 'video/x-matroska' );
        } else if ( detailsFormat === 'video' ) {
            mediaUrl = await storeMedia( aid, uid, createId( 'vid' ) + '.mkv', videoBlob, 'video/x-matroska' );
        }

        const cd = new Date( commDate + ' ' + commTime );

        let added = [];
        if ( commType === 'Call' ) {
            const call = {
                name: desc,
                commDate: cd.toJSON(),
                duration: duration,
                detailsType: detailsFormat,
                details: details,
                direction: direction,
                audio: ( detailsFormat === 'audio' ),
                video: ( detailsFormat === 'video' ),
                outcome: outcome,
                mediaUrl: mediaUrl
            };
    
            added = await logCall( aid, uid, call, [ cid ] );
        } else if ( commType === 'Email' ) {
            const email = {
                name: desc,
                commDate: cd.toJSON(),
                subject: desc,
                to: to,
                cc: cc,
                from: from,
                body: details,
                detailsType: detailsFormat,
                audio: ( detailsFormat === 'audio' ),
                video: ( detailsFormat === 'video' ),
                mediaUrl: mediaUrl
            };
    
            added = await logEmail( aid, uid, email, [ cid ] );
        } else if ( commType === 'Txt' ) {
            const sms = {
                name: desc,
                commDate: cd.toJSON(),
                detailsType: detailsFormat,
                details: details,
                direction: direction,
                audio: ( detailsFormat === 'audio' ),
                video: ( detailsFormat === 'video' ),
                mediaUrl: mediaUrl
            };
    
            added = await logSms( aid, uid, sms, [ cid ] );
        }
        
        if ( added.length ) {
            toast.success( `The ${commType} has been recorded`, { theme: 'dark' } );
            close();
        }
        if ( onSave ) {
            await onSave( oid );
        }
    }

    const launchRecorder = ( type ) => {
        setVideoFormat( type );
        setShowVideo( true );
    }

    useEffect( () => {
        if ( videoBlob ) {
            refVideo.current.src = URL.createObjectURL( videoBlob );
        }
    }, [ videoBlob ] );

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '550px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Log a {commType}</Col>
                </Row>
                {
                    processing ? (
                        <Fragment>
                            <Row className='py-3'>
                                <Col className='text-center'>
                                    <Spinner animation="border" variant='primary' role="status" />
                                </Col>
                            </Row>
                        </Fragment>
                    ) : (
                        <Container fluid className='p-0 overflow-scroll' style={ { maxHeight: '80vh' }}>
                            {
                                ( commType === 'Call' ) ? (
                                    <Fragment>
                                        <Row className='py-3'>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Brief Description of the Call</Form.Label>
                                                    <Form.Control className='tf-modal-text-input' type="text" placeholder="Enter a description" value={desc} onChange={ ( e ) => setDesc( e.target.value ) } />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className='py-3'>
                                            <Col>
                                                <Form.Group as={Row}>
                                                    <Form.Label column xs='auto'>This Call was Made or Received?</Form.Label>
                                                    <Col xs='auto'>
                                                        <Form.Select size='sm' className='tf-modal-select-input' value={direction} onChange={ ( e ) => setDirection( e.target.value ) }>
                                                            <option value='outbound' selected={ direction === 'outbound' }>Made</option>
                                                            <option value='inbound' selected={ direction === 'inbound' }>Received</option>
                                                        </Form.Select>
                                                    </Col>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className='py-3'>
                                            <Col xs='auto'>
                                                <Form.Group>
                                                    <Form.Label>When did the call happen?</Form.Label>
                                                    <Form.Control className='tf-modal-text-input' type="date" value={commDate} onChange={ ( e ) => setCommDate( e.target.value ) } />
                                                </Form.Group>
                                            </Col>
                                            <Col xs='auto'>
                                                <Form.Group>
                                                    <Form.Label>&nbsp;</Form.Label>
                                                    <Form.Control className='tf-modal-text-input' type="time" value={commTime} onChange={ ( e ) => setCommTime( e.target.value ) } />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className='py-3'>
                                            <Col>
                                                <Form.Group as={Row}>
                                                    <Form.Label column xs='auto'>How long was the call for?</Form.Label>
                                                    <Col xs='auto'>
                                                        <InputGroup className='tf-modal-text-input'>
                                                            <Form.Control className='tf-modal-text-input' type="number" value={duration} onChange={ ( e ) => setDuration( e.target.value ) } />
                                                            <InputGroup.Text className='tf-modal-text-input'>minutes</InputGroup.Text>
                                                        </InputGroup>
                                                    </Col>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className='py-3'>
                                            <Col>
                                                <Form.Group as={Row}>
                                                    <Form.Label column xs='auto'>What was the outcome of the call?</Form.Label>
                                                    <Col xs='auto'>
                                                        <Form.Select size='sm' className='tf-modal-select-input' value={outcome} onChange={ ( e ) => setOutcome( e.target.value ) }>
                                                            <option value='talked' selected={ outcome === 'talked' }>Talked</option>
                                                            <option value='voicemail' selected={ outcome === 'voicemail' }>Left Voicemail</option>
                                                            <option value='missed' selected={ outcome === 'missed' }>Missed Call</option>
                                                        </Form.Select>
                                                    </Col>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Fragment>
                                ) : (
                                    null
                                )
                            }
                            {
                                ( commType === 'Email' ) ? (
                                    <Fragment>
                                        <Row className='pt-3 pb-1'>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Email Subject</Form.Label>
                                                    <Form.Control className='tf-modal-text-input' type="text" placeholder="Subject..." value={desc} onChange={ ( e ) => setDesc( e.target.value ) } />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className='py-1'>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>To</Form.Label>
                                                    <Form.Control className='tf-modal-text-input' type="text" placeholder="To..." value={to} onChange={ ( e ) => setTo( e.target.value ) } />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className='py-1'>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Cc</Form.Label>
                                                    <Form.Control className='tf-modal-text-input' type="text" placeholder="Cc..." value={cc} onChange={ ( e ) => setCc( e.target.value ) } />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className='pt-1 pb-3'>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>From</Form.Label>
                                                    <Form.Control className='tf-modal-text-input' type="text" placeholder="From..." value={from} onChange={ ( e ) => setFrom( e.target.value ) } />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className='py-3'>
                                            <Col xs='auto'>
                                                <Form.Group>
                                                    <Form.Label>When did the email happen?</Form.Label>
                                                    <Form.Control className='tf-modal-text-input' type="date" value={commDate} onChange={ ( e ) => setCommDate( e.target.value ) } />
                                                </Form.Group>
                                            </Col>
                                            <Col xs='auto'>
                                                <Form.Group>
                                                    <Form.Label>&nbsp;</Form.Label>
                                                    <Form.Control className='tf-modal-text-input' type="time" value={commTime} onChange={ ( e ) => setCommTime( e.target.value ) } />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Fragment>
                                ) : (
                                    null
                                )
                            }
                            {
                                ( commType === 'Txt' ) ? (
                                    <Fragment>
                                        <Row className='py-3'>
                                            <Col>
                                                <Form.Group>
                                                    <Form.Label>Brief Description of the Txt</Form.Label>
                                                    <Form.Control className='tf-modal-text-input' type="text" placeholder="Enter a description" value={desc} onChange={ ( e ) => setDesc( e.target.value ) } />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className='py-3'>
                                            <Col>
                                                <Form.Group as={Row}>
                                                    <Form.Label column xs='auto'>This Txt was Sent or Received?</Form.Label>
                                                    <Col xs='auto'>
                                                        <Form.Select size='sm' className='tf-modal-select-input' value={direction} onChange={ ( e ) => setDirection( e.target.value ) }>
                                                            <option value='outbound' selected={ direction === 'outbound' }>Sent</option>
                                                            <option value='inbound' selected={ direction === 'inbound' }>Received</option>
                                                        </Form.Select>
                                                    </Col>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className='py-3'>
                                            <Col xs='auto'>
                                                <Form.Group>
                                                    <Form.Label>When did the txt happen?</Form.Label>
                                                    <Form.Control className='tf-modal-text-input' type="date" value={commDate} onChange={ ( e ) => setCommDate( e.target.value ) } />
                                                </Form.Group>
                                            </Col>
                                            <Col xs='auto'>
                                                <Form.Group>
                                                    <Form.Label>&nbsp;</Form.Label>
                                                    <Form.Control className='tf-modal-text-input' type="time" value={commTime} onChange={ ( e ) => setCommTime( e.target.value ) } />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Fragment>
                                ) : (
                                    null
                                )
                            }
                            
                            <Row className='py-1 align-items-center'>
                                <Col xs='auto'>
                                    How do you want to log this?
                                </Col>
                                <Col xs='auto'>
                                    <Button variant='link' size='sm' style={ { color: ( detailsFormat === 'text' ) ? 'var( --tf-orange )' : '#000' } } onClick={ () => setDetailsFormat( 'text' ) }>
                                        <KeyboardIcon />
                                    </Button>    
                                </Col>
                                <Col xs='auto'>
                                    <Button variant='link' size='sm' style={ { color: ( detailsFormat === 'audio' ) ? 'var( --tf-orange )' : '#000' } } onClick={ () => setDetailsFormat( 'audio' ) }>
                                        <MicIcon />
                                    </Button>
                                </Col>
                                <Col xs='auto'>
                                    <Button variant='link' size='sm' style={ { color: ( detailsFormat === 'video' ) ? 'var( --tf-orange )' : '#000' } } onClick={ () => setDetailsFormat( 'video' ) }>
                                        <VideocamIcon />
                                    </Button>
                                </Col>
                            </Row>
                            {
                                ( detailsFormat === 'text' ) ? (
                                    <Row className='py-3'>
                                        <Col>
                                            <Form.Group>
                                                {/* <Form.Label>Details of the {commType}</Form.Label> */}
                                                <Form.Control className='tf-modal-text-input' as="textarea" rows={3} placeholder="Details..." value={details} onChange={ ( e ) => setDetails( e.target.value ) } />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                ) : (
                                    null
                                )
                            }
                            {
                                ( detailsFormat === 'audio' ) ? (
                                    <Fragment>
                                        <Row className='py-3 justify-content-center'>
                                            <Col>
                                                <TFAudioRecorder setBlob={setAudioBlob} />
                                            </Col>
                                        </Row>
                                    </Fragment>
                                ) : (
                                    null
                                )
                            }
                            {
                                ( detailsFormat === 'video' ) ? (
                                    <Fragment>
                                        <Row className='py-3 justify-content-center'>
                                            <Col xs='auto'>
                                                <Button variant='outline-primary' onClick={ () => launchRecorder( 'face' ) }>
                                                    <AccountBoxIcon />
                                                    <div className='pt-1' style={{fontSize: '10px'}}>Face Only</div>
                                                </Button>    
                                            </Col>
                                            <Col xs='auto'>
                                                <Button variant='outline-primary' disabled>
                                                    <PersonalVideoIcon />
                                                    <div className='pt-1' style={{fontSize: '10px'}}>Screen Only<br />(coming soon)</div>
                                                </Button>
                                            </Col>
                                            <Col xs='auto'>
                                                <Button variant='outline-primary' disabled>
                                                    <AccountBoxIcon />
                                                    <div className='pt-1' style={{fontSize: '10px'}}>Face & Screen<br />(coming soon)</div>
                                                </Button>    
                                            </Col>
                                        </Row>
                                        <Row className='py-3 justify-content-center'>
                                            <Col>
                                                {
                                                    ( videoBlob ) ? (
                                                        <video controls autoPlay playsInline ref={refVideo} style={ { width: '400px' } }></video>
                                                    ) : (
                                                        null
                                                    )
                                                }
                                            </Col>
                                        </Row>
                                    </Fragment>
                                ) : (
                                    null
                                )
                            }
                            <Row className='py-3'>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => create() } disabled={!ready}>Save</Button>
                                </Col>
                                <Col xs='auto'>
                                    <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                                </Col>
                            </Row>
                            <Modal open={showVideo} onClose={ () => setShowVideo( false ) }>
                                <TFVideoRecorder vidType={ videoFormat } setBlob={ setVideoBlob } close={ () => setShowVideo( false ) } />
                            </Modal>
                        </Container>
                    )
                }
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( LogComms );